"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z50: "#FEFCF9",
  z100: "#FFF1E6",
  z200: "#F9D0A9",
  z300: "#F4A266",
  z400: "#ED8449",
  z500: "#E86C37",
  z600: "#CE501A",
  z700: "#B53B12",
  z800: "#802C10",
  z900: "#661A00"
};